import { all, put, call, takeLatest } from 'redux-saga/effects';
import * as http from 'utils/http';
import config from 'config';
import { setLoading, setCurrentCarrier, updateDriver } from './duck';
import { SERVICES } from 'tenant/config';

// @effect Action
const mounted$ = 'carrier-section/mounted$';
const unmounted$ = 'carrier-section/unmounted$';
const updated$ = 'carrier-section/updated$';
const updatedDriver$ = 'carrier-section/updatedDriver$';

// @effect Creators
export const carrierSectionMounted = (payload) => ({
  type: mounted$,
  payload,
});

export const carrierSectionUnMounted = (payload) => ({
  type: unmounted$,
  payload,
});

export const carrierUpdated = (payload) => ({
  type: updated$,
  payload,
});

export const driverUpdated = (payload) => ({
  type: updatedDriver$,
  payload,
});

const getChildUsers = (array) => {
  return Promise.all(
    array.map(async (child) => {
      if (!child.user_set) {
        return child;
      }

      const user_set = await Promise.all(child.user_set.map(async (user) => await http.get(user)));

      return {
        ...child,
        user_set,
      };
    })
  );
};

function* handleDriverUpdated({ payload }) {
  const id = payload;
  const driver = yield call(http.get, `${config.API_URL}drivers/${id}`);

  const currentDriver = {
    ...driver,
    user_set: yield [http.get(driver.user_set[0])],
  };

  yield put(updateDriver(currentDriver));
}

function* handleSectionMounted({ payload }) {
  const { id } = payload;

  yield put(setLoading(true));

  const [carrier, drivers, vehicles] = yield all([
    call(http.get, `${config.API_URL}carriers/${id}/`),
    call(http.get, `${config.API_URL}drivers/?carrier=${id}&page_size=0`),
    call(http.get, `${config.API_URL}vehicles/?carrier=${id}&page_size=0`),
  ]);

  let documents = [];

  if (SERVICES.DOCUMENTATION) {
    try {
      documents = yield call(http.get, `${config.BASE_URL}/api/dms/documents/carrier/${id}/`);
    } catch (err) {
      console.error(err);
    }
  }
  const currentCarrier = {
    ...carrier,
    drivers: yield getChildUsers(drivers),
    vehicles: vehicles.map((vehicle) => ({
      ...vehicle,
      carrier,
    })),
    documents,
  };

  yield put(setCurrentCarrier(currentCarrier));

  yield put(setLoading(false));
}

function* handleSectionUnMounted() {
  yield put(setCurrentCarrier(null));
  yield put(setLoading(false));
}

function* handleUpdatedCarrier({ payload }) {
  let currentCarrier = null;
  const id = payload;
  if (id) {
    yield put(setLoading(true));
    const [carrier, drivers, vehicles] = yield all([
      call(http.get, `${config.API_URL}carriers/${id}/`),
      call(http.get, `${config.API_URL}drivers/?carrier=${id}&page_size=0`),
      call(http.get, `${config.API_URL}vehicles/?carrier=${id}&page_size=0`),
    ]);

    if (drivers && vehicles) {
      currentCarrier = {
        ...carrier,
        drivers: yield getChildUsers(drivers),
        vehicles: vehicles.map((vehicle) => ({
          ...vehicle,
          carrier,
        })),
      };
    }

    yield put(setCurrentCarrier(currentCarrier));
    yield put(setLoading(false));
  }
}

// Watchers
export function* watchCarrierSection() {
  yield takeLatest(mounted$, handleSectionMounted);
  yield takeLatest(unmounted$, handleSectionUnMounted);
  yield takeLatest(updated$, handleUpdatedCarrier);
  yield takeLatest(updatedDriver$, handleDriverUpdated);
}
